export const EnvTypeConfig  = {
    dev : { env :'dev' , url : 'https://dev-www.lexis360intelligence.fr' },
    cert: { env : 'cert' , url : 'https://cert-www.lexis360intelligence.fr' },
    prod: { env : 'prod', url : 'https://www.lexis360intelligence.fr' }
}